export const UpdateDebounceConfig = 500;
//# sourceMappingURL=timeoutConfiguration.js.map